export const keys = {
  bootstrap: () => ['bootstrap'] as const,
  weather: () => ['weather'] as const,
  plans: {
    all: () => ['plans'] as const,
    window: (from: string, to: string) => ['plans', 'window', from, to] as const,
  },
  tasks: {
    all: () => ['tasks'] as const,
    list: (doneSince: string) => ['tasks', 'list', doneSince] as const,
  },
  habits: {
    list: () => ['habits', 'list'] as const,
    allLogs: () => ['habits', 'logs'] as const,
    logs: (from: string, to: string) => ['habits', 'logs', from, to] as const,
  },
  prayer: {
    times: (date: string) => ['prayer', 'times', date] as const,
    methods: () => ['prayer', 'methods'] as const,
  },
  alarms: {
    list: () => ['alarms', 'list'] as const,
  },
  quran: {
    surahs: () => ['quran', 'surahs'] as const,
    page: (surah: number, translation: string) => ['quran', 'surah', surah, translation] as const,
    verse: (date: string, translation: string) => ['quran', 'verse', date, translation] as const,
  },
  exchange: () => ['exchange', 'rates'] as const,
  kanji: {
    list: () => ['kanji', 'list'] as const,
    progress: () => ['kanji', 'progress'] as const,
  },
  geocode: (q: string) => ['geocode', q] as const,
  members: () => ['members'] as const,
  devices: () => ['devices'] as const,
};
